import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="language-selector"
export default class extends Controller {
  static targets = ["input", "preview"]
  static values = { 
    storageKey: String,
    defaultLanguage: String 
  }

  connect() {
    this.loadSavedLanguage()
    this.updatePreview()
  }

  languageChanged(event) {
    const selectedLanguage = event.target.value
    this.saveLanguage(selectedLanguage)
    this.updatePreview()
    this.dispatchLanguageChangeEvent(selectedLanguage)
  }

  loadSavedLanguage() {
    if (!this.hasStorageKeyValue) return

    const savedLanguage = localStorage.getItem(this.storageKeyValue)
    if (savedLanguage && this.isValidLanguage(savedLanguage)) {
      this.selectLanguage(savedLanguage)
    }
  }

  saveLanguage(language) {
    if (!this.hasStorageKeyValue) return
    localStorage.setItem(this.storageKeyValue, language)
  }

  selectLanguage(language) {
    const input = this.inputTargets.find(input => input.value === language)
    if (input) {
      input.checked = true
    }
  }

  updatePreview() {
    const selectedLanguage = this.getSelectedLanguage()
    
    this.previewTargets.forEach(preview => {
      const previewType = preview.dataset.previewType
      
      switch (previewType) {
        case 'title':
          preview.textContent = selectedLanguage === 'fr' ? "TABLEAU D'HONNEUR" : "HONOR ROLL"
          break
        case 'subtitle':
          preview.textContent = selectedLanguage === 'fr' ? "HONOUR ROLL" : "TABLEAU D'HONNEUR"
          break
        case 'flag':
          preview.textContent = selectedLanguage === 'fr' ? '🇫🇷' : '🇬🇧'
          break
        case 'language_name':
          preview.textContent = selectedLanguage === 'fr' ? 'Français' : 'English'
          break
      }
    })
  }

  getSelectedLanguage() {
    const checkedInput = this.inputTargets.find(input => input.checked)
    return checkedInput ? checkedInput.value : this.defaultLanguageValue
  }

  isValidLanguage(language) {
    return ['fr', 'en'].includes(language)
  }

  dispatchLanguageChangeEvent(language) {
    const event = new CustomEvent('honor-roll:language-changed', {
      detail: { language },
      bubbles: true
    })
    this.element.dispatchEvent(event)
  }
}